import { render, staticRenderFns } from "./StartForm14.vue?vue&type=template&id=06570d94&scoped=true"
import script from "./StartForm14.vue?vue&type=script&lang=ts"
export * from "./StartForm14.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06570d94",
  null
  
)

export default component.exports